/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { LabelCell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const Leadership = ({
    isLeadership,
    hasLeadershipComponent,
    serviceLeadershipRole,
}: Partial<{
    isLeadership: boolean;
    hasLeadershipComponent: string;
    serviceLeadershipRole: string;
}>) => (
    <>
        {isLeadership ||
            (hasLeadershipComponent === 'true' && (
                <Row>
                    <LabelCell label="This is a leadership activity" />
                </Row>
            ))}
        {serviceLeadershipRole && (
            <Row>
                <ValueCell label="Leadership Role" value={serviceLeadershipRole} />
            </Row>
        )}
    </>
);

export default Leadership;
